import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ValidatorService } from "../services/validation.service";
import { HTMLGenricComponent } from "../common/JSON/htmlComponent/HTML-Genric-Component.JSON";
import { WelcomePageService } from '../services/welcome-Page.service';
import { WCPageDetailsResponseJSON } from "./../common/JSON/wcPage/WC-Page-Details-Response-JSON";
import { InputHTMLComponentJSON } from "./../common/JSON/htmlComponent/Input-HTML-Component-JSON";
import { QuestionDetailsHeaderRequestJSON } from "./../common/JSON/RequestTOJSON/Question-Details-Header-Request.JSON";
import { SurveyDeployerQuestionPageRequestJSON } from "./../common/JSON/RequestTOJSON/Survey-Deployer-Question-Page-Request.JSON";
import { RequestService } from "../request.service";
import { HTMLDisplayComponentRequestJSON } from "../common/JSON/RequestTOJSON/HTML-Display-Component-Request.JSON";
import { HTMLDisplayComponentJSON } from "../common/JSON/htmlComponent/HTML-Display-Component-JSON";
import { HTMLComponentJSON } from "../common/JSON/htmlComponent/HTML-Component-JSON";
import { WCPageServiceRequestJSON } from "./../common/JSON/RequestTOJSON/WC-Page-Service-Request.JSON";
import { SurveyDeployerConfigResponseJSON } from "./../common/JSON/surveyConfig/Survey-Deployer-Config-Response-JSON";
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'welcome-page',
  templateUrl: './welcome.component.html',
  styles: [
    `.loader-ring h1 {
            color: #555;
            font-size: 2em;
            font-weight: 400;
        }
        .thank-you h1 {
            color: #555;
            font-size: 2em;
            font-weight: 400;
            text-align:center;
        }
        .thank-you p {
            text-align: center;
            word-wrap: break-word;
            width: 250px;
        }
        .loader.container-fluid {

            background: #ffffff none repeat scroll 0 0;
            height: 78px;
            position: relative;
            z-index: 5;
        }

        .loader-ring.text-container {
            margin: 10% auto;
        }

        .logo-image {

            width: auto;
            float: left;
            margin: 14px;
        }

        .thank-you h1 {
            color: #555;
            font-size: 2em;
            font-weight: 400;
        }
        
        .thank-you p {
            margin: 0 auto;
            width: 280px;
        }

        img.loader {
            position: absolute;
            top: 50%;
            left: 46%;
        }`
  ]
})

export class WelcomePageComponent implements OnInit {
  @Input() error;
  @Input() loading;
  @Input() expire;
  @Input() thanks;
  @Input() wCPageDetailsResponseJSON: WCPageDetailsResponseJSON;
  @Output() parentEmitter = new EventEmitter();
  private dateFormatEnable: IMyDpOptions = {
    // other options...
    dateFormat: 'dd.mm.yyyy',
    componentDisabled: false
  };
  private dateFormatDisable: IMyDpOptions = {
    // other options...
    dateFormat: 'dd.mm.yyyy',
    componentDisabled: true
  };
  questionDetailsHeaderRequestJSON: QuestionDetailsHeaderRequestJSON;
  surveyDeployerQuestionPageRequestJSON: SurveyDeployerQuestionPageRequestJSON;
  wCPageServiceRequestJSON: WCPageServiceRequestJSON;
  username: string;
  email: string;

  validationMessage: string;
  htmlToAdd;
  readOnlyflag: boolean;
  private surveyID: Number;
  private itemsPerRow: number;
  public rows: number[];

  constructor(private validatorService: ValidatorService,
    private requestService: RequestService,
    private welcomePageService: WelcomePageService,
    private hTMLGenricComponent: HTMLGenricComponent) {
    // this.surveyID=this.wCPageDetailsResponseJSON.surveyID;
    this.itemsPerRow = 2;
    this.surveyDeployerQuestionPageRequestJSON = new SurveyDeployerQuestionPageRequestJSON;
  }

  ngOnInit(): void {
    this.surveyID = this.wCPageDetailsResponseJSON.surveyID;
    console.log("WelcomePageComponent" + this.wCPageDetailsResponseJSON);
    this.htmlToAdd = this.wCPageDetailsResponseJSON.welcomePageText;
    this.rows = Array.from(Array(Math.ceil(this.wCPageDetailsResponseJSON.listSize / this.itemsPerRow)).keys());

    if(this.wCPageDetailsResponseJSON.alreadySubmitted || this.wCPageDetailsResponseJSON.alreadySaved) {
      this.submitInfo(this.wCPageDetailsResponseJSON);
    }
  }

  //set date value on submitting data
  setDateValueFromDatePicker(wCPageDetailsResponseJSON: WCPageDetailsResponseJSON) {
    wCPageDetailsResponseJSON.hHTMLDisplayComponentJSONList.forEach(hHTMLDisplayComponentJSON => {
      hHTMLDisplayComponentJSON.inputHTMLComponentJSONList.forEach(inputHTMLComponentJSON => {
        if (!inputHTMLComponentJSON.autoPopulate && inputHTMLComponentJSON.type == 7) {
          inputHTMLComponentJSON.value = inputHTMLComponentJSON["dateValue"]["formatted"];
        }
      });
    });
  }

  submitInfo(wCPageDetailsResponseJSON: WCPageDetailsResponseJSON) {
    this.setDateValueFromDatePicker(wCPageDetailsResponseJSON);
    var error ;
    if(!this.wCPageDetailsResponseJSON.alreadySubmitted && !this.wCPageDetailsResponseJSON.alreadySaved){
     error = this.validatorService.validate(wCPageDetailsResponseJSON['hHTMLDisplayComponentJSONList']);
  }
  else {
    error = false;
  }
    this.wCPageServiceRequestJSON = this.convertSpecificToGenericInput(wCPageDetailsResponseJSON, this.requestService.getConfig());
    if (error == false) {

      this.loading = true;
      this.welcomePageService.postUserInfo(this.wCPageServiceRequestJSON)
        .subscribe(out => {
          this.requestService.setUsernameEmailCompanyMobile(out.response.questionDetailsHeaderRequestJSON.userName,
            out.response.questionDetailsHeaderRequestJSON.email,
            out.response.questionDetailsHeaderRequestJSON.companyName,
            out.response.questionDetailsHeaderRequestJSON.mobileName,
            out.response.questionDetailsHeaderRequestJSON.surveyStatus,
            out.response.surveyUserGeneratedID,
            out.response.questionDetailsHeaderRequestJSON.employeeCode
          );
          console.log(out.response.surveyDeployerWCPageValidationJSON);
          this.loading = false;
          if (out.response.surveyDeployerWCPageValidationJSON.pageRedirectTo == "Page404") {
            this.error = true;
            this.expire = false;
            this.thanks = false;
            this.loading = false;
          } else if (out.response.surveyDeployerWCPageValidationJSON.pageRedirectTo == "ExpirePage") {
            this.error = false;
            this.expire = true;
            this.thanks = false;
            this.loading = false;
          } else if (out.response.surveyDeployerWCPageValidationJSON.pageRedirectTo == "SuccessWCP") {
            window.scroll(0,0);
            this.parentEmitter.emit();
          }
        }, err => {
          this.error = true;
          this.expire = false;
          this.thanks = false;
          this.loading = false;
        })
    } else {
      wCPageDetailsResponseJSON['hHTMLDisplayComponentJSONList'] = error;
    }
  }


  readOnlyState(inputHTMLComponentJSON: InputHTMLComponentJSON) {
    if (inputHTMLComponentJSON.viewable && !inputHTMLComponentJSON.editable) {
      this.readOnlyflag = true;
    } else {
      this.readOnlyflag = false;
    }
    return this.readOnlyflag;
  }

  // convertStringToDate(value){
  //   var date;
  //   date=new Date("27/02/2014");
  //   return date;
  // }

  // fetchQuestions(surveyID:Number){
  //   this.parentEmitter.emit();
  // }

  // radio button check event
  selectRadio(event, group, item) {
    // remove error
    this.removeError(event, group);
    // unselect other and select this item
    if (event.sourceElement.checked) {
      group.selectedIndex == item.index;
    }
  }

  selectCheckbox(event, group, item) {
    // remove error
    this.removeError(event, group);
    if (event.sourceElement.checked) {
      group.selectedIndex.push(item.index);
    } else {
      var index = group.selectedIndex.indexOf(item.index);
      group.selectedIndex.splice(index, 1);
    }
  }

  convertSpecificToGenericInput(wCPageDetailsResponseJSON: WCPageDetailsResponseJSON, surveyDeployerConfigResponseJSON: SurveyDeployerConfigResponseJSON) {

    var wCPageServiceRequestJSON = new WCPageServiceRequestJSON;
    wCPageServiceRequestJSON.surveyID = wCPageDetailsResponseJSON.surveyID;
    wCPageServiceRequestJSON.itemsPerRow = wCPageDetailsResponseJSON.itemsPerRow;
    wCPageServiceRequestJSON.listSize = wCPageDetailsResponseJSON.listSize;
    wCPageServiceRequestJSON.surveyDeployerConfigResponseJSON = surveyDeployerConfigResponseJSON;
    wCPageServiceRequestJSON.welcomePageText = wCPageDetailsResponseJSON.welcomePageText;
    wCPageServiceRequestJSON.hHTMLDisplayComponentJSONList = this.converthHTMLDisplayComponentJSONList(wCPageDetailsResponseJSON.hHTMLDisplayComponentJSONList);

    return wCPageServiceRequestJSON;
  }

  converthHTMLDisplayComponentJSONList(HTMLDisplayComponentJSONList: HTMLDisplayComponentJSON[]) {
    var hTMLDisplayComponentRequestJSONList = new Array<HTMLDisplayComponentRequestJSON>();
    HTMLDisplayComponentJSONList.forEach(element => {
      var hTMLDisplayComponentRequestJSON = new HTMLDisplayComponentRequestJSON;
      hTMLDisplayComponentRequestJSON.componentTypeID = element.componentTypeID;
      hTMLDisplayComponentRequestJSON.displayLable = element.displayLable;
      hTMLDisplayComponentRequestJSON.selectedCheckBox = element.selectedCheckBox;
      hTMLDisplayComponentRequestJSON.selectedDropDown = element.selectedDropDown;
      hTMLDisplayComponentRequestJSON.selectedRadio = element.selectedRadio;

      hTMLDisplayComponentRequestJSON.inputHTMLComponentJSONList = this.convertInputHTMLComponentJSON(element.inputHTMLComponentJSONList);

      hTMLDisplayComponentRequestJSONList.push(hTMLDisplayComponentRequestJSON);
    });
    return hTMLDisplayComponentRequestJSONList;
  }

  convertInputHTMLComponentJSON(hTMLComponentJSONList: HTMLComponentJSON[]) {
    //every Type
    var hTMLGenricComponentList = new Array<HTMLGenricComponent>();
    hTMLComponentJSONList.forEach(element => {
      var hTMLGenricComponent = new HTMLGenricComponent;
      var keys = Object.keys(element);
      keys.forEach(key => {
        hTMLGenricComponent[key] = element[key];
      });
      hTMLGenricComponentList.push(hTMLGenricComponent);
    });
    return hTMLGenricComponentList;
  }

  removeError(event, inputHTMLComponentJSON) {
    event.preventDefault();
    inputHTMLComponentJSON.errorMessage = undefined;
  }
}
